import React, { useContext } from "react";
import styled from "styled-components";
import { UIContext } from "../../../contexts/UIContext";
import { DataContext } from "../../../contexts/DataContext";
import { Link } from "react-router-dom";
import HyperLogo from "../../../Images/HyperLogo.png";
import { UserContext } from "../../../contexts/UserContext";

const Main = styled.div``;

const Content = styled.div`
  padding-left: 10px;
  padding-right: 10px;
  position: fixed;
  top: 60px;
  left: ${(props) => (props.expanded ? "0px" : "-230px")};
  bottom: 0;
  z-index: 100;
  width: 230px;
  background-color: #1d2939;
  transition: all 0.2s ease-in-out;
  padding-top: 40px;
`;

const Ul = styled.ul`
  margin: 0;

  list-style-type: none;
  padding-left: 0;
  transition: all 0.2s ease-in-out;
`;
const Li = styled.li`
  margin-top: 1px;
  > ul {
    margin-left: 0.5em;
  }
`;
const A = styled(Link)`
  display: flex;
  align-items: center;
  border-radius: 0.25rem;
  color: ${(props) =>
    props.selected ? props.theme.highlightColour : "#adb5bd"};
  background-color: ${(props) => (props.selectedbg ? "#141d28" : "")};
  cursor: pointer;
  display: flex;
  line-height: 20px;
  justify-content: space-between;
  text-decoration: none;
  margin: 0;
  padding: 0.375rem 1rem;
  font-weight: ${(props) => (props.bold ? 500 : 300)};
  :hover {
    background-color: #141d28;
    color: #fff;
  }
`;

const A_STATIC = styled.div`
  display: flex;
  align-items: center;
  border-radius: 0.25rem;
  color: ${(props) =>
    props.selected ? props.theme.highlightColour : "#adb5bd"};
  background-color: ${(props) => (props.selectedbg ? "#141d28" : "")};
  cursor: pointer;
  display: flex;
  line-height: 20px;
  justify-content: space-between;
  text-decoration: none;
  margin: 0;
  padding: 0.375rem 1rem;
  font-weight: ${(props) => (props.bold ? 500 : 300)};
  :hover {
    background-color: #141d28;
    color: #fff;
  }
`;

const LogoContainer = styled.div`
  position: fixed;
  top: 0;
  left: ${(props) => (props.expanded ? "0px" : "-230px")};
  width: 230px;
  height: 60px;
  background-color: #141c27;
  border-right: 1px solid rgba(0, 0, 0, 0.15);
  box-shadow: 0 1px 4px 0px rgba(0, 0, 0, 0.16);
  font-size: 24px;
  font-weight: 700;
  padding: 0 20px;
  display: flex;
  align-items: center;
  z-index: 1030;
  transition: all 0.2s ease-in-out;
  justify-content: center;
`;
const Logo = styled.img`
  height: 20px;
`;
export default function Sidebar() {
  const { navigationView, setNavigationView, showSideBar } =
    useContext(UIContext);
  const { user } = useContext(UserContext);

  return (
    <Main>
      <LogoContainer expanded={showSideBar}>
        <Logo src={HyperLogo} />
      </LogoContainer>
      <Content expanded={showSideBar}>
        <Ul>
          {/* <Li>
            <A_STATIC
              href="#"
              bold="true"
              onClick={() => {
                document.location = window.location.origin + "/football";
              }}
            >
              Football
              <FiChevronDown />
            </A_STATIC>
          </Li>
          <Li>
            <A_STATIC
              href="#"
              bold="true"
              onClick={() => {
                document.location = window.location.origin + "/rugby";
              }}
            >
              Rugby
              <FiChevronDown />
            </A_STATIC>
          </Li> */}
          <Li>
            <A
              href="#"
              bold="true"
              selected={
                true ||
                (navigationView && navigationView.split("/")[0] === "Netball")
              }
              onClick={() => {
                setNavigationView("Netball/");
              }}
              to={""}
            >
              Netball
              {/* <FiChevronDown /> */}
            </A>
            {/* {navigationView && navigationView.split("/")[0] === "Football" && ( */}
            <Ul>
              <Li
                onClick={() => {
                  setNavigationView("Netball/Fixtures");
                }}
              >
                <A
                  to="/Netball/Fixtures"
                  selected={
                    navigationView && navigationView === "Netball/Fixtures"
                  }
                  selectedbg={
                    navigationView && navigationView === "Netball/Fixtures"
                  }
                >
                  Fixtures
                </A>
              </Li>
              <Li
                onClick={() => {
                  setNavigationView("Netball/Teams");
                }}
              >
                <A
                  to="/Netball/Teams"
                  selected={
                    navigationView && navigationView === "Netball/Teams"
                  }
                  selectedbg={
                    navigationView && navigationView === "Netball/Teams"
                  }
                >
                  Teams
                </A>
              </Li>
              {/* <Li
                onClick={() => {
                  setNavigationView("Netball/Players");
                }}
              >
                <A
                  to="/Netball/Players"
                  selected={
                    navigationView && navigationView === "Netball/Players"
                  }
                  selectedBG={
                    navigationView && navigationView === "Netball/Players"
                  }
                >
                  Players
                </A>
              </Li> */}
              <Li
                onClick={() => {
                  setNavigationView("Netball/Stadiums");
                }}
              >
                <A
                  to="/Netball/Stadiums"
                  selected={
                    navigationView && navigationView === "Netball/Stadiums"
                  }
                  selectedbg={
                    navigationView && navigationView === "Netball/Stadiums"
                  }
                >
                  Stadiums
                </A>
              </Li>
              <Li
                onClick={() => {
                  setNavigationView("Netball/Officials");
                }}
              >
                <A
                  to="/Netball/Officials"
                  selected={
                    navigationView && navigationView === "Netball/Officials"
                  }
                  selectedbg={
                    navigationView && navigationView === "Netball/Officials"
                  }
                >
                  Officials
                </A>
              </Li>
              {/* <Li
                onClick={() => {
                  setNavigationView("Netball/Transfers");
                }}
              >
                <A
                  to="/Netball/Transfers"
                  selected={
                    navigationView && navigationView === "Netball/Transfers"
                  }
                  selectedBG={
                    navigationView && navigationView === "Netball/Transfers"
                  }
                >
                  Transfers
                </A>
              </Li> */}
              <Li
                onClick={() => {
                  setNavigationView("Netball/Countries");
                }}
              >
                <A
                  to="/Netball/Countries"
                  selected={
                    navigationView && navigationView === "Netball/Countries"
                  }
                  selectedbg={
                    navigationView && navigationView === "Netball/Countries"
                  }
                >
                  Countries
                </A>
              </Li>
              <Li
                onClick={() => {
                  setNavigationView("Netball/Competitions");
                }}
              >
                <A
                  to="/Netball/Competitions"
                  selected={
                    navigationView && navigationView === "Netball/Competitions"
                  }
                  selectedbg={
                    navigationView && navigationView === "Netball/Competitions"
                  }
                >
                  Competitions
                </A>
              </Li>
              <Li
                onClick={() => {
                  setNavigationView("Netball/Seasons");
                }}
              >
                <A
                  to="/Netball/Seasons"
                  selected={
                    navigationView && navigationView === "Netball/Seasons"
                  }
                  selectedbg={
                    navigationView && navigationView === "Netball/Seasons"
                  }
                >
                  Seasons
                </A>
              </Li>
              {/* <Li
                onClick={() => {
                  setNavigationView("Netball/Formations");
                }}
              >
                <A
                  to="/Netball/Formations"
                  selected={
                    navigationView && navigationView === "Netball/Formations"
                  }
                  selectedbg={
                    navigationView && navigationView === "Netball/Formations"
                  }
                >
                  Formations
                </A>
              </Li> */}
            </Ul>
            {/* )} */}
          </Li>
          {user?.roles?.findIndex((i) => i == "admin" || i == "support") >
            -1 && (
            <Li>
              <A
                href="#"
                bold="true"
                selected={
                  true ||
                  (navigationView && navigationView.split("/")[0] === "System")
                }
                onClick={() => {
                  setNavigationView("System/");
                }}
              >
                System Support
                {/* <FiChevronDown /> */}
              </A>
              <Ul>
                <Li
                  onClick={() => {
                    setNavigationView("System/opta");
                  }}
                >
                  <A
                    to="/System/opta"
                    selected={
                      navigationView && navigationView === "System/opta"
                    }
                    selectedbg={
                      navigationView && navigationView === "System/opta"
                    }
                  >
                    OPTA
                  </A>
                </Li>
                <Li
                  onClick={() => {
                    setNavigationView("System/monitoring");
                  }}
                >
                  <A
                    to="/System/monitoring"
                    selected={
                      navigationView && navigationView === "System/monitoring"
                    }
                    selectedbg={
                      navigationView && navigationView === "System/monitoring"
                    }
                  >
                    Monitoring
                  </A>
                </Li>

                <Li
                  onClick={() => {
                    setNavigationView("System/logs");
                  }}
                >
                  <A
                    to="/System/logs"
                    selected={
                      navigationView && navigationView === "System/logs"
                    }
                    selectedbg={
                      navigationView && navigationView === "System/logs"
                    }
                  >
                    Logs
                  </A>
                </Li>
                <Li
                  onClick={() => {
                    setNavigationView("System/viz");
                  }}
                >
                  <A
                    to="/System/viz"
                    selected={navigationView && navigationView === "System/viz"}
                    selectedbg={
                      navigationView && navigationView === "System/viz"
                    }
                  >
                    Viz Engines
                  </A>
                </Li>
                <Li
                  onClick={() => {
                    setNavigationView("System/Users");
                  }}
                >
                  <A
                    to="/System/Users"
                    selected={
                      navigationView && navigationView === "System/Users"
                    }
                    selectedbg={
                      navigationView && navigationView === "System/Users"
                    }
                  >
                    Users
                  </A>
                </Li>
                <Li
                  onClick={() => {
                    setNavigationView("System/Database");
                  }}
                >
                  <A
                    to="/System/Database"
                    selected={
                      navigationView && navigationView === "System/Database"
                    }
                    selectedbg={
                      navigationView && navigationView === "System/Database"
                    }
                  >
                    Database
                  </A>
                </Li>
                <Li
                  onClick={() => {
                    setNavigationView("System/Config");
                  }}
                >
                  <A
                    to="/System/Config"
                    selected={
                      navigationView && navigationView === "System/Config"
                    }
                    selectedbg={
                      navigationView && navigationView === "System/Config"
                    }
                  >
                    Config
                  </A>
                </Li>
                <Li
                  onClick={() => {
                    setNavigationView("System/Settings");
                  }}
                >
                  <A
                    to="/System/Settings"
                    selected={
                      navigationView && navigationView === "System/Settings"
                    }
                    selectedbg={
                      navigationView && navigationView === "System/Settings"
                    }
                  >
                    Settings
                  </A>
                </Li>
              </Ul>
            </Li>
          )}
        </Ul>
      </Content>
    </Main>
  );
}
